import { VideoPlayer } from '@dragonchain-dev/dragon-kit';
import * as React from 'react';
export default {
  VideoPlayer,
  React
};